module.exports = __webpack_public_path__ + "media/images/placeholders/angebot-a39516b4fa7c21068f3eebce3f204a19.jpg";